const MER_BEAR_ORANGE_PINEAPPLE = 'mer-bear-orange-pineapple';
const MER_BEAR_LEMON_BLACK_RASPBERRY = 'mer-bear-lemon-black-raspberry';
const MER_BEAR_STRAWBERRY_BLUE_PUNCH = 'mer-bear-strawberry-blue-punch';
const UNI_SHARK_PINEAPPLE_POMEGRANATE = 'uni-shark-pineapple-pomegranate';
const UNI_SHARK_LYCHEE_KIWI = 'uni-shark-lychee-kiwi';
const UNI_SHARK_LIME_MANGO = 'uni-shark-lime-mango';

export default {
  MER_BEAR_ORANGE_PINEAPPLE,
  MER_BEAR_LEMON_BLACK_RASPBERRY,
  MER_BEAR_STRAWBERRY_BLUE_PUNCH,
  UNI_SHARK_PINEAPPLE_POMEGRANATE,
  UNI_SHARK_LYCHEE_KIWI,
  UNI_SHARK_LIME_MANGO,
}

// export default {
//   MER_BEAR_ORANGE_PINEAPPLE: MER_BEAR_ORANGE_PINEAPPLE,
//   MER_BEAR_LEMON_BLACK_RASPBERRY: MER_BEAR_LEMON_BLACK_RASPBERRY,
//   MER_BEAR_STRAWBERRY_BLUE_PUNCH: MER_BEAR_STRAWBERRY_BLUE_PUNCH,
//   UNI_SHARK_PINEAPPLE_POMEGRANATE: UNI_SHARK_PINEAPPLE_POMEGRANATE,
//   UNI_SHARK_LYCHEE_KIWI: UNI_SHARK_LYCHEE_KIWI,
//   UNI_SHARK_LIME_MANGO: UNI_SHARK_LIME_MANGO,
// }
